/**
 * 認証エラー関連の Reducer
 */
import { AUTH_ERROR_BY_LOGIN_TYPE_REDIRECT } from '../actions/AuthErrorActions';
const initialState = {
    isRedirectByLoginType: false,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case AUTH_ERROR_BY_LOGIN_TYPE_REDIRECT:
            return {
                isRedirectByLoginType: action.payload.isRedirectByLoginType,
            };
        default:
            return state;
    }
};
